import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubscriptionsRoutingModule } from './subscriptions-routing.module';
import { ListSubscriptionsComponent } from './list-subscriptions/list-subscriptions.component';
import { SharedModule } from 'app/shared/shared.module';
import { EditSubscriptionComponent } from './edit-subscription/edit-subscription.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShowSubscriptionComponent } from './show-subscription/show-subscription.component';

@NgModule({
  declarations: [
    ListSubscriptionsComponent,
    EditSubscriptionComponent,
    ShowSubscriptionComponent,
  ],
  imports: [
    CommonModule,
    SubscriptionsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SubscriptionsModule {}
